import { useQuery } from '@tanstack/react-query';
import { getDesiredEnergy } from '../../../api/nutrition-service';

const useGetDesiredEnergy = () => {
    const {
        data: desiredData,
        isLoading: isLoadingDesired,
        isError: isErrorDesired,
        error: desiredError
    } = useQuery({
        queryKey: ['desired-energy'],
        queryFn: () => getDesiredEnergy(),
        enabled: true,
        staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: false
    });

    return { desiredData, isLoadingDesired, isErrorDesired, desiredError };
};

export default useGetDesiredEnergy;
